<template>
  <vue-final-modal
    :value="value"
    :name="name"
    :classes="['letter-example-sentence-dialog__container']"
    :content-class="[
      'letter-example-sentence-dialog__content',
      'v--modal-box',
      'v--modal'
    ]"
    :click-to-close="true"
    :esc-to-close="true"
    :lock-scroll="true"
    attach="body"
    @input="$emit('input', $event)"
    @opened="onOpened"
  >
    <div class="v--modal-close-top">
      <el-button
        icon="el-icon-close"
        type="text"
        @click="$emit('input', false)"
      />
    </div>
    <div class="title">例文を選ぶ</div>
    <div class="description">
      <p>選択した例文が追加されます。</p>
      <p class="attention">
        例文を選択すると、現在入力中の文章は上書きされますのでご注意ください。
      </p>
    </div>
    <ul class="example-sentence">
      <li
        v-for="(item, index) in items"
        :key="index"
        @click="onSelect(item.sentences)"
      >
        <div class="title">{{ item.name }}</div>
        <div class="body" v-html="item.sentences"></div>
      </li>
    </ul>
    <div class="text-right">
      <el-button @click="$emit('input', false)">閉じる</el-button>
    </div>
  </vue-final-modal>
</template>

<script setup lang="ts">
import { nextTick } from 'vue'

export type LetterExampleSentenceItem = {
  name: string
  sentences: string
  type?: string
}

defineProps<{
  value: boolean
  name: string
  items: LetterExampleSentenceItem[]
}>()

const emit = defineEmits<{
  (e: 'input', value: boolean): void
  (e: 'select', sentences: string): void
}>()

/** margin-block:auto 縦中央だと overflow コンテナが下端寄りに開くことがあるので上寄せ＋scroll リセット */
function onOpened() {
  nextTick(() => {
    document
      .querySelectorAll('.letter-example-sentence-dialog__container')
      .forEach((el) => {
        ;(el as HTMLElement).scrollTop = 0
      })
  })
}

function onSelect(sentences: string) {
  emit('select', sentences.replace(/<br>/gi, '\n'))
  emit('input', false)
}
</script>

<!--
  旧 vue-js-modal: adaptive + scrollable + height="auto"（width 未指定 = 600px）。
  Pattern A: :styles flex 禁止。配置・スクロールは __container。
  attach=body 時の absolute を fixed 化（ページ縦スクロール位置に依存しない）。
-->
<style lang="scss">
@import '@/assets/scss/format-edit/vfm-attach-body-fixed';
@include vfm-root-fixed-when-has('.letter-example-sentence-dialog__container');

.letter-example-sentence-dialog__container {
  display: flex;
  align-items: flex-start;
  justify-content: center;
  box-sizing: border-box;
  width: 100%;
  height: 100%;
  padding: 20px 0;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
}

.letter-example-sentence-dialog__content.v--modal-box.v--modal {
  position: relative;
  box-sizing: border-box;
  flex: 0 1 auto;
  width: 600px;
  max-width: 100%;
  height: auto;
  margin: 0 auto;
  padding: 20px 20px 50px;
  left: 0 !important;
}

.letter-example-sentence-dialog__content .title {
  font-size: 1.2rem;
  font-weight: bold;
  margin-bottom: 0.75rem;
}

.letter-example-sentence-dialog__content .v--modal-close-top {
  text-align: right;
}

.letter-example-sentence-dialog__content .description .attention {
  color: #e3165c;
}
</style>
